import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import Image from "react-bootstrap/Image";
import klogo from "../assets/images/klogo.webp";
import { useEffect } from "react";
import { Collapse } from "bootstrap";

function AppHeader() {
  const handleNavLinkClick = () => {
    const navbar = document.querySelector(".navbar-collapse");
    if (navbar && navbar.classList.contains("show")) {
      // Get the Bootstrap Collapse instance
      let bsCollapse = Collapse.getInstance(navbar);

      // If instance is not available, create a new one
      if (!bsCollapse) {
        bsCollapse = new Collapse(navbar, {
          toggle: false,
        });
      }
      // Hide the navbar on link click
      bsCollapse.hide();
    }
  };

  useEffect(() => {
    const loadBootstrap = async () => {
      await import("bootstrap/dist/js/bootstrap.bundle.min.js");
    };
    loadBootstrap();
  }, []);

  return (
    <Navbar className="my-navbar" bg="light" expand="lg">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <Image
            src={klogo}
            alt="Kanchan Logo"
            width="450"
            height="450"
            className="d-inline-block align-top me-2"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto nav-links">
            <Nav.Link as={Link} to="/" onClick={handleNavLinkClick}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/academics" onClick={handleNavLinkClick}>
              Academics
            </Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={handleNavLinkClick}>
              About
            </Nav.Link>
            <Nav.Link as={Link} to="/gallery" onClick={handleNavLinkClick}>
              Gallery
            </Nav.Link>
            <Nav.Link as={Link} to="/mandatory" onClick={handleNavLinkClick}>
              Mandatory
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={handleNavLinkClick}>
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default AppHeader;
